import { AdasBox, AdasButton, AdasTypography } from '@components/wrapper-components'

// Only admins and owners may set up a location's Scheduler (the backend refuses everyone else), so other
// roles are told who can do it instead of being offered a button that fails.
export const canSetupScheduler = (user) => !!(user && (user.is_admin || user.is_owner))

export const SchedulerSetupPrompt = ({ currentUser, onSetup }) => {
  if (!canSetupScheduler(currentUser)) {
    return (
      <AdasBox>
        <AdasTypography>The Scheduler hasn&apos;t been set up for this location yet. Ask the location owner to set it up.</AdasTypography>
      </AdasBox>
    )
  }
  return (
    <>
      <AdasBox>
        <AdasTypography>Please setup the Scheduler for managing the appointments</AdasTypography>
      </AdasBox>
      <AdasButton variant='contained' onClick={onSetup}>
        SETUP
      </AdasButton>
    </>
  )
}
